<template>
<div>
    <b-modal ref="modal" hide-footer >
        <div class="row">
            <div class="col text-center">
                <b-button class="mr-2" variant="outline-primary">Hoje</b-button>

                <b-button class="mr-2" variant="outline-primary">Esta Semana</b-button>
                <b-button class="mr-2" variant="outline-primary">Este Mês</b-button>

            </div>
        </div>

        <hr />

            <div class="row">
                <div class="col-12 text-center">
                    <date-input></date-input>
                    <date-input></date-input>
                    <button class="btn btn-primary text-center">Selecionar</button>
                </div>
            </div>
    </b-modal>

</div>
</template>

<script>
export default {

    methods: {
        open() {
            this.$refs.modal.show();
        }

    },
};
</script>

<style>
</style>
